<section class="page-container">
  <div class="flex min-w-0 items-center justify-between gap-4">
    <h1 class="main-heading min-w-0">Vehicle Stock Availability</h1>
    <app-navpath class="hidden md:block" />
  </div>
  <section class="content-container">
    <div class="w-full border-b pb-4 md:max-w-xl">
      <app-data-form
        [dataFields]="upperFormFields"
        [dataName]="'upperFormFields'"
        [columns]="1"
        (updateFields_child)="handleUpdate($event)"
      ></app-data-form>
    </div>
    <p *ngIf="loading" class="my-4" role="status">
      Loading vehicle stock availability...
    </p>
    <p *ngIf="statusMessage" class="my-4" role="status">
      {{ statusMessage }}
    </p>
    <div
      *ngIf="tableVisible"
      class="my-4 w-full overflow-x-auto border-b pb-4"
    >
      <app-data-table
        [tableHeaders]="tableHeaders"
        [tableEntries]="tableEntries"
        [pageSize]="25"
        (open)="openEntry($event)"
        class="block min-w-[56rem]"
      ></app-data-table>
    </div>

    <p class="mt-8 text-red-500">
      <strong>Disclaimer</strong>: The expected shipment arrival dates
      in months depicted <strong>are estimates only</strong>. While we
      try our best to keep the stock details up to date, they do not
      necessarily reflect the latest information available from the
      HMC due to factory glitches, union strikes, vessel delays,
      homologations and other events which are out of our control.
      <br />
      <br />
      You are reminded to advise your customers that the expected
      shipment arrival dates
      <strong>may be subjected to delays</strong>.
    </p>
  </section>
</section>
